import React, { useEffect, useState } from "react";
import { FaAngleDoubleDown } from "react-icons/fa";
// Custom Components
import Landing from "../../pages/landing/Landing";
import AudioPlayer from "../audio-player/AudioPlayer";
// Assets
import bgm from "../../assets/audio/bgm.mp3";
// Styles
import "./landing-animation.css";

function LandingAnimation(props) {
  const { isLandingLoading } = props;

  const [envelopeOpen, setEnvelopeOpen] = useState(false);
  const [guideAnimation, setGuideAnimation] = useState(false);
  const [letterReveal, setLetterReveal] = useState(false);
  const [animationFadeOut, setAnimationFadeOut] = useState(false);
  const [showLandingPage, setShowLandingPage] = useState(false);
  const [audioPlaying, setAudioPlaying] = useState(false);
  const [showAudioControl, setShowAudioControl] = useState(false);

  let guideTimer = null;

  useEffect(() => {
    const timer = setTimeout(() => {
      setEnvelopeOpen(true);
    }, 1000);

    guideTimer = setTimeout(() => {
      setGuideAnimation(true);
    }, 4000);

    return () => {
      clearTimeout(timer);
      clearTimeout(guideTimer);
    };
  }, []);

  const handleRevealLetter = (e) => {
    e.stopPropagation();
    clearTimeout(guideTimer);
    setLetterReveal(true);
    setGuideAnimation(false);
    setAudioPlaying(true);
    setShowAudioControl(true);

    setTimeout(() => {
      setAnimationFadeOut(true);
    }, 3700);

    setTimeout(() => {
      setShowLandingPage(true);
    }, 4300);
  };

  let render = showLandingPage ? (
    <Landing isLandingLoading={isLandingLoading} />
  ) : (
    <section
      className={`animation-container ${animationFadeOut ? "fade-out" : ""}`}
    >
      <div className={`envelope-container ${setLetterReveal ? "clicked" : ""}`}>
        <span
          className="pulse-remark-container"
          style={{
            animation: guideAnimation
              ? "fadeInOut 2s infinite ease-in-out"
              : "none",
          }}
        >
          <p>Click me!</p>
          <FaAngleDoubleDown className="envelope-pulse-arrow" />
        </span>

        <div
          id="envelope"
          className={`${envelopeOpen ? "open" : "close"} ${
            letterReveal ? "reveal" : ""
          }`}
          style={{
            animation: guideAnimation
              ? "pulse 2s infinite ease-in-out"
              : "none",
          }}
          onClick={handleRevealLetter}
        >
          <div className="front flap"></div>
          <div className="front pocket"></div>
          <div className="letter">
            <div className="words line1"></div>
            <div className="words line2"></div>
            <div className="words line3"></div>
            <div className="words line4"></div>
          </div>

          <div className="hearts">
            <div className="heart a1"></div>
            <div className="heart a2"></div>
            <div className="heart a3"></div>
          </div>
        </div>
      </div>
    </section>
  );

  return (
    <>
      <AudioPlayer
        audio={bgm}
        isAudioPlaying={audioPlaying}
        isShowControl={showAudioControl}
      />
      {render}
    </>
  );
}

export default LandingAnimation;
